import { cva } from 'class-variance-authority';

export const tabsWrapperClasses = cva('flex', {
  variants: {
    variant: {
      default: 'p-0-5',
      pill: 'w-full gap-1 rounded-full bg-[#0A0A0A]/[0.045] p-1'
    }
  },
  defaultVariants: {
    variant: 'default'
  }
});

export const buttonWrapperClasses = cva(['text-sm transition-colors'], {
  variants: {
    isActive: {
      true: 'bg-cloud-50 border border-[#E6E6E6]',
      false: 'text-[#737373]'
    },
    variant: {
      default: '',
      pill: 'flex-1 rounded-full border-none px-6 py-2'
    }
  },
  compoundVariants: [
    {
      variant: 'pill',
      isActive: true,
      className: 'bg-white-50 border-none shadow-sm'
    },
    {
      variant: 'pill',
      isActive: false,
      className: 'bg-transparent'
    }
  ],
  defaultVariants: {
    isActive: false,
    variant: 'default'
  }
});

export const selectWrapperClasses = cva(
  'focus:ring-cloud-50 cursor-pointer rounded-full border border-[#E6E6E6] p-2 text-sm focus:ring-2'
);
